export default "__VITE_ASSET__CrY$cRDQ__"